import React, { useState, useEffect, useRef } from "react"
import { Form, Input, Button } from "antd"

const MasterCardForm = ({ form, service }) => {
  const { getFieldDecorator, validateFields } = form
  const [loading, setLoading] = useState(false)
  const inputRef = useRef(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault()
    validateFields((err, values) => {
      if (!err) {
       console.log(values)
        setLoading(true)
        setTimeout(() => {
          setLoading(false)
          console.log("Mastercard transaction completed.")
        }, 2000)
      }
    })
  }

  const handleBarcodeInput = (event) => {
    if (event.key === "Enter") {
      handleSubmit(event) 
    }
  }

  return (
    <Form className="redeem-form" layout="vertical" onSubmit={handleSubmit}>
      <Form.Item label="Scansiona Codice">
        {getFieldDecorator("barcodeValue", {
          rules: [{ required: true, message: "Scansiona il codice a barre!" }],
        })(
          <Input
            ref={inputRef}
            placeholder="Scansiona Codice"
            suffix={<i className="fal fa-barcode-read" />}
            onKeyUp={handleBarcodeInput}
          />
        )}
      </Form.Item>

      <Button
        type="primary"
        className="redeem-button"
        htmlType="submit"
        loading={loading}
        style={{ backgroundColor: service.colorBg, borderColor: service.colorBg }}
      >
        Attivazione
      </Button>
    </Form>
  )
}

export default Form.create()(MasterCardForm)
